// extracted by mini-css-extract-plugin
export default {"shell":"AppShell_shell__08MH3","main":"AppShell_main__ApWLB"};